// Storage/request limits; rendering budgets are defined separately by the export service.
export const GRID_MAX_BANNERS = 50;
export const GRID_MAX_BYTES = 4 * 1024 * 1024;
export const GRID_MAX_COMMANDS = 200;
export const GRID_SVG_MAX_STOPS = 64;
export const GRID_GENERATIVE_MIN_COUNT = 3;
export const GRID_GENERATIVE_MAX_COUNT = 20;
export const GRID_GENERATIVE_MIN_STOPS = 2;
export const GRID_GENERATIVE_MAX_STOPS = 8;
export const GRID_GENERATIVE_MAX_CONFLICTS = GRID_GENERATIVE_MAX_COUNT * (GRID_GENERATIVE_MAX_COUNT - 1) / 2;
